<template>
  <div class="masterMap">
    <!-- 标的弹窗 -->
    <el-dialog
      :title="titleVal"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="mastermapVisible"
      width="650px"
      class="symbolDialog"
    >
      <div class="masterMap_Cen">
        <div class="fl masterMap_left">
          <!-- left主图指标pitchon -->
          <div class="masterMap_left_top">
            <ul class="scroll-bar scroll-bar-gray">
              <li v-for="(item,idx) in dataPropertyTOList" :key="idx">
                <span
                  @click="paramSelect(item)"
                  :title="item.code+'-'+item.name"
                  :class="{'pitchon':item.code==paramData.code&&item.name==paramData.name}"
                  class="ellipsis tianjia fl"
                >{{item.code}}</span>
                <span
                  class="fr"
                  style="padding-top: 4px;"
                  v-if="formatting(item)"
                  @click="iconAdd(item,idx)"
                >
                  <img src="@/assets/image/svg/icon-tianjia.svg" class="iconAdd" />
                </span>
                <span
                  class="fr"
                  v-else
                  style="color: #57A3EF; font-size: 12px; height: 30px;  line-height: 30px;
               font-family: MicrosoftYaHei;cursor: context-menu;"
                >已选择</span>
              </li>
            </ul>
          </div>
          <!-- left已选择 -->
          <h3 class="seleLeft">已选择</h3>
          <div class="masterMap_left_Dn">
            <ul class="scroll-bar scroll-bar-gray">
              <li v-for="(item,idx) in subject" :key="idx">
                <span
                  @click="paramSelect(item)"
                  :title="item.code+'-'+item.name"
                  :class="{'pitchon':item.code==paramData.code&&item.name==paramData.name}"
                  class="ellipsis tianjia fl"
                >{{item.code}}</span>
                <span class="fr" v-if="subject.length>1">
                  <i class="el-icon-delete delete" @click="deleteFun(item,idx)"></i>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <!-- right主图指标详情 -->
        <div class="fr masterMap_Right">
          <div class="scroll-bar scroll-bar-gray">
            <h3 class="titName">{{paramData.code}}-{{paramData.name}}</h3>
            <p v-html="paramData.remarks.replace(/\n/g, '<br>')"></p>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="save(false)" size="mini" :disabled="!subject.length>0">取 消</el-button>
        <el-button type="primary" @click="save(true)" size="mini"  :disabled="!subject.length>0">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    // 初始化数据
    headerData: {
      type: Object,
      required: true
    },
    // 已选择数据
    dataTOList: {
      type: Array,
      required: true
    },
    // 是否弹窗
    mastermapVisible: {
      type: Boolean,
      required: true
    },
     titleVal: {
      type: String
    }
  },
  data() {
    return {
      paramData: {
        code: "",
        name: "",
        remarks: ""
      },
      paramType: "0",
      loading: false,
      dataPropertyTOList: [],
      typeInit: true,
      subject: [],
      getData: []
    };
  },
  methods: {
    ngInitList(){
       let subjects =  [...this.dataTOList];
       this.subject = subjects;
    },
    // 添加
    iconAdd(item) {
      if(this.subject.filter(items=>items==item).length==0){
        this.subject.push(item)
      }
    },
    // 删除
    deleteFun(item, idx) {
      this.subject = this.subject.filter(items => items != item);
    },
    // 格式化
    formatting(item) {
      if (this.subject.find(items => items.code == item.code)) {
        return false;
      } else {
        return true;
      }
     
    },
    // 选择详情
    paramSelect(item) {
      this.paramData = {};
      this.paramData = item;
    },
    // 保存
    save(type) {
      // this.mastermapVisible = false;
      this.$emit("onMaster", this.subject, type);
    },
    // 选择行情
    selectBtn(item) {
      this.subject = item;
    },
    ngOnInit() {
      // THIS.paramSelect
      this.dataPropertyTOList = this.headerData.dataPropertyTOList;
      this.paramSelect(this.dataPropertyTOList[0])
    }
  },
  deactivated() {
    this.ngOnInit();
  },
  mounted() {},
  created() {}
};
</script>
<style lang="less" scoped>
// 弹窗
.masterMap {
  /deep/ .el-dialog__header {
    box-shadow: 0px 0px 4px 0px rgba(153, 153, 153, 1);
  }
  /deep/ .el-dialog__title {
    line-height: 24px;
    color: #57a3ef;
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
  }
  /deep/ .el-dialog__body {
    padding: 20px 20px 0px 20px;
  }
  .selectLi {
    background: #e9f4ff;
    color: #57a3ef;
  }
  .delete {
    color: #dc6342;
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
  }
  .iconAdd {
    font-size: 18px;
    color: #666666;
    margin-top: 2px;
    cursor: pointer;
  }
  .masterMap_Cen {
    clear: both;
    overflow: hidden;
    // 上
    .masterMap_left_top {
      height: 214px;
      border: 1px solid #dddddd;
      padding-left: 20px;
      ul {
        padding-right: 20px;
        li {
          clear: both;
          overflow: hidden;
          margin-bottom: 9px;
          cursor: pointer;
        }
      }
    }
    // 下
    .masterMap_left_Dn {
      height: 150px;
      border: 1px solid #dddddd;
      padding-left: 20px;
      > ul {
        padding-right: 20px;
        li {
          clear: both;
          overflow: hidden;
          margin-bottom: 9px;
          cursor: pointer;
        }
      }
    }
    .masterMap_left {
      width: 298px;
      .tianjia {
        width: 200px;
        height: 30px;
        line-height: 30px;
      }
    }
    .masterMap_Right {
      margin-left: 20px;
      width: 290px;
      padding-left: 26px;
      border: 1px solid #dddddd;
      height: 394px;
      .titName {
        font-size: 12px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #57a3ef;
        margin-bottom: 10px;
      }
      .scroll-bar {
        padding-bottom: 10px;
        padding-right: 4px;
      }
    }
  }
  .pitchon {
    background: #57a3ef;
    color: #fff;
    border-radius: 4px;
    padding-left: 10px;
  }
}
.seleLeft{
  color: #57a3ef;
    font-size: 14px;
    height: 30px;
    line-height: 36px;
}
</style>
